import React from 'react';
import BannerSection from '../../components/BannerSection';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';

const ShopDetails = () => {
    return (
        <div>
            <Navbar />
            <BannerSection />
            <div id="shop-content">
                <div class="container">
                    <div class="shop-details-content">
                        <div class="row justify-content-center cus-pad">
                            <div class="col-lg-6">
                                <div class="xzoom-container">
                                    <img class="xzoom5" id="xzoom-magnific" alt="image" src="images/01.png"
                                        xoriginal="images/01.png" />
                                    <div class="xzoom-thumbs">
                                        <div class="all-slider">
                                            <a href="images/01.png">
                                                <img class="xzoom-gallery5" alt="image" src="images/01.png" />
                                            </a>
                                            <a href="images/02.png">
                                                <img class="xzoom-gallery5" alt="image" src="images/02.png" />
                                            </a>
                                            <a href="images/03.png">
                                                <img class="xzoom-gallery5" alt="image" src="images/03.png" />
                                            </a>
                                            <a href="images/04.png">
                                                <img class="xzoom-gallery5" alt="image" src="images/04.png" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="right-item">
                                    <h4>Revolution Pro Controller</h4>
                                    <p>Comfort, precision and customisation: all of NACON's expertise
                                        has gone into the REVOLUTION Pro Controller 2 for PS4™.
                                        Includes full software, headset jack and a 3m USB-C cable.</p>
                                    <div class="review">
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star"></i></a>
                                        <a href="#"><i class="fas fa-star-half-alt"></i></a>
                                        <span class="text-sm">4.3 (79)</span>
                                    </div>
                                    <div class="prize">
                                        <p>€129.90</p>
                                        <span class="text-sm">As low as</span>
                                    </div>
                                    <div class="bottom-area d-flex align-items-center">
                                        <h5>€79.90</h5>
                                        <div class="qtySelector text-center">
                                            <i class="fas fa-minus decreaseQty"></i>
                                            <input type="text" class="qtyValue" value="1" />
                                            <i class="fas fa-plus increaseQty"></i>
                                        </div>
                                        <a href="#" class="cmn-btn">Add to Basket</a>
                                    </div>
                                    <div class="social d-flex align-items-center">
                                        <p>Share:</p>
                                        <ul class="d-flex">
                                            <li><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                                            <li><a href="#"><i class="fab fa-twitter"></i></a></li>
                                            <li><a href="#"><i class="fab fa-instagram"></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <section id="products-content" class="pb-120">
                <div class="container">
                    <div class="row">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="description-tab" data-toggle="tab" href="#description" role="tab"
                                    aria-controls="description" aria-selected="true">description</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="information-tab" data-toggle="tab" href="#information" role="tab"
                                    aria-controls="information" aria-selected="false">Additional information</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="reviews-tab" data-toggle="tab" href="#reviews" role="tab"
                                    aria-controls="reviews" aria-selected="false">reviews (5)</a>
                            </li>
                        </ul>
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="description" role="tabpanel" aria-labelledby="description-tab">
                                <div class="description">
                                    <div class="single">
                                        <h5>Stay one step ahead</h5>
                                        <p>This fully customisable controller offers features and settings specially designed for eSports,
                                            so you can adapt to any competitive gameplay style.</p>
                                    </div>
                                    <div class="single">
                                        <h5>Features</h5>
                                        <p>Inheriting all the features that made the first REVOLUTION Pro Controller such a success, it also adds new customisation features for
                                            competitive gamers. With two sticks using NACON-patented technology to provide up to 46° amplitude,
                                            you can play with unrivalled precision.</p>
                                    </div>
                                    <div class="single">
                                        <h5>Technical specifications</h5>
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="single-side">
                                                    <h6>Connectivity</h6>
                                                    <ul>
                                                        <li><span>Connection</span> <span>Detachable USB-C/USB cable</span></li>
                                                        <li><span>Wireless</span> <span>No</span></li>
                                                        <li><span>Cable included</span> <span>Yes</span></li>
                                                        <li><span>Cable length (cm)</span> <span>300</span></li>
                                                        <li><span>Software</span> <span>Yes</span></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="single-side">
                                                    <h6>Ergonomics</h6>
                                                    <ul>
                                                        <li><span>Joystick position</span> <span>Asymmetric</span></li>
                                                        <li><span>Wireless</span> <span>Profiles</span></li>
                                                        <li><span>Programmable buttons</span> <span>Yes</span></li>
                                                        <li><span>Backlighting</span> <span>RGB</span></li>
                                                        <li><span>LED player indicator</span> <span>Yes</span></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="information" role="tabpanel" aria-labelledby="information-tab">
                                <div class="information">
                                    <div class="single">
                                        <h5>Drivers and downloads</h5>
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="single-side">
                                                    <h6>Documents</h6>
                                                    <ul>
                                                        <li><span>Certificate of Conformity</span> <span><a href="#">Download</a></span></li>
                                                        <li><span>User Manual</span> <span><a href="#">Download</a></span></li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="single-side">
                                                    <h6>Software</h6>
                                                    <ul>
                                                        <li><span>Mac OS X</span> <span><a href="#">Download</a></span></li>
                                                        <li><span>Windows</span> <span><a href="#">Download</a></span></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="reviews" role="tabpanel" aria-labelledby="reviews-tab">
                                <div class="comments">
                                    <div class="single">
                                        <h5>Comments</h5>
                                        <div class="row">
                                            <div class="col-lg-8">
                                                <div class="comments-side">
                                                    <div class="comment-single d-flex">
                                                        <div class="avatar">
                                                            <img src="images/admin-img-1.png" alt="image" />
                                                        </div>
                                                        <div class="comnt-text">
                                                            <div class="reply-icon">
                                                                <a href="#">Reply <img src="images/reply-icon.png" alt="image" /></a>
                                                            </div>
                                                            <div class="comnt-info">
                                                                <div class="name-review d-flex align-items-center">
                                                                    <h6>Lindsey Dokidis</h6>
                                                                    <div class="review">
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                    </div>
                                                                </div>
                                                                <p class="text-sm date">November 20, 2021 at 8:31 pm</p>
                                                                <p class="text-sm">Maecenas at turpis ut lacus posuere dapibus. Fusce et sollicitudin libero,
                                                                    id vehicula sem. Morbi pharetra nisl eget neque commodo facilisis. Nunc malesuada dolor vitae.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="comment-single mid d-flex">
                                                        <div class="avatar">
                                                            <img src="images/admin-img-2.png" alt="image" />
                                                        </div>
                                                        <div class="comnt-text">
                                                            <div class="reply-icon">
                                                                <a href="#">Reply <img src="images/reply-icon.png" alt="image" /></a>
                                                            </div>
                                                            <div class="comnt-info">
                                                                <div class="name-review d-flex align-items-center">
                                                                    <h6>Alfredo Carder</h6>
                                                                    <div class="review">
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                    </div>
                                                                </div>
                                                                <p class="text-sm date">November 25, 2021 at 8:31 pm</p>
                                                                <p class="text-sm">Maecenas at turpis ut lacus posuere dapibus. Fusce et sollicitudin libero,
                                                                    id vehicula sem. Morbi pharetra nisl eget neque commodo facilisis. Nunc malesuada dolor vitae.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="comment-single d-flex">
                                                        <div class="avatar">
                                                            <img src="images/admin-img-3.png" alt="image" />
                                                        </div>
                                                        <div class="comnt-text">
                                                            <div class="reply-icon">
                                                                <a href="#">Reply <img src="images/reply-icon.png" alt="image" /></a>
                                                            </div>
                                                            <div class="comnt-info">
                                                                <div class="name-review d-flex align-items-center">
                                                                    <h6>Alfredo Carder</h6>
                                                                    <div class="review">
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                        <a href="#"><i class="fas fa-star"></i></a>
                                                                    </div>
                                                                </div>
                                                                <p class="text-sm date">November 25, 2021 at 8:31 pm</p>
                                                                <p class="text-sm">Maecenas at turpis ut lacus posuere dapibus. Fusce et sollicitudin libero,
                                                                    id vehicula sem. Morbi pharetra nisl eget neque commodo facilisis. Nunc malesuada dolor vitae.</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="comment-form">
                                                    <div class="top-area">
                                                        <h5>Add A Review</h5>

                                                        <div class="star-area d-flex align-items-center justify-content-between">
                                                            <span>Your Rating:</span>
                                                            <ul class="d-flex">
                                                                <li>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                </li>
                                                                <li>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                </li>
                                                                <li>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                </li>
                                                                <li>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                </li>
                                                                <li>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                    <a href="#"><i class="fas fa-star"></i></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <form action="#" method="post">
                                                        <div class="form-group">
                                                            <label for="name">Name</label>
                                                            <input type="text" id="name" class="form-control" placeholder="Enter your Name" />
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="email">Email</label>
                                                            <input type="email" id="email" class="form-control" placeholder="Enter your email" />
                                                        </div>
                                                        <div class="form-group">
                                                            <label for="email">Message</label>
                                                            <textarea class="form-control" rows="10" placeholder="Enter your message"></textarea>
                                                        </div>
                                                        <button class="cmn-btn" type="submit">POST COMMENT</button>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <Footer />

        </div>
    );
}

export default ShopDetails;